import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Numeric from './Numeric'
import DropdownList from './DropdownList'
import TextInput from './TextInput'
import DateQuestion from './Date'

@observer
class Form extends Component {
    questionGetTitle = (question) => {
        const { store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        console.log('questionGetTitle')
        const titleObj = question.content.shortTitle
        console.log(JSON.stringify(question.content, null, 4))
        if (titleObj[langcode]) {
            ({ text } = titleObj[langcode])
        } else if (titleObj[defaultLocale]) {
            ({ text } = titleObj[defaultLocale])
        } else if (titleObj[initialLocale]) {
            ({ text } = titleObj[initialLocale])
        }

        return store.replaceOptionMerge(text)
    }

    formOption = (option, index) => {
        const { store, question } = this.props
        const { questionTypeCode } = option.question
        let element
        switch (questionTypeCode) {
            case 'I':
                element = <Numeric />
                break
            case 'SB':
                element = <DropdownList langCode={store.langcode} />
                break
            case 'TX':
                element = <TextInput />
                break
            case 'DT':
                element = <DateQuestion />
                break
        }

        const validationMsg = option.question.hasOwnProperty('validator')
                && option.question.validator.error
                && !Object.values(option.question.validator.otherValidation).some(validation => validation.error)
            ? <div
                style={{
                    height: '25px', width: 0, position: 'relative', alignSelf: 'center',
                }}>
                <i className={`formValidationError validation_${questionTypeCode} fal fa-exclamation-circle`}></i>
            </div>
            : null

        element = React.cloneElement(element, {
            index,
            question: option.question,
            formId: question.id,
            store,
            printMode: store.printMode,
            validationMsg,
        })

        const infoIconValues = option.question.settings.frontend.info

        const getText = (option) => {
            const { langcode } = store
            const { defaultLocale } = store.data.metadata
            const { initialLocale } = question

            console.log(`info icon tooltip: ${JSON.stringify(option)}`, langcode, defaultLocale)
            let text = ''
            if (option[langcode]) {
                ({ text } = option[langcode])
            } else if (option[defaultLocale]) {
                ({ text } = option[defaultLocale])
            } else if (option[initialLocale]) {
                ({ text } = option[initialLocale])
            }

            return text
        }

        const infoIcon = infoIconValues
            ? (
                <div className="formInfoIcon">
                    <i className="fas fa-info-circle"></i>
                    <span className="tooltiptext top" dangerouslySetInnerHTML={{ __html: getText(infoIconValues) }}></span>
                </div>
            ) : null
        return (
            <div style={{ padding: '10px 0px', borderBottom: '1px solid #DDD', alignItems: 'center' }} className="formElement">
                <span className="formLabel">
                    {this.questionGetTitle(option.question)}
                </span>
                <div className={`formOption ${validationMsg ? 'optionValidationError' : ''}`}>
                    {element}
                </div>
                {infoIcon}
            </div>
        )
    }

    removeValidationErrors = () => {
        const { question } = this.props
        question.optionSet.forEach((option) => {
            if (R.pathOr(false, ['question', 'validator', 'error'], option)) {
                option.question.validator.error = false
            }
        })
    }

    render() {
        const { question } = this.props
        const validationErrors = question.optionSet.filter(o => o.question.validator.error)
        return (
            <div className={`formQuestion ${validationErrors.length > 0 ? 'validationError' : ''}`} onFocus={this.removeValidationErrors}>
                <div className="validationContainer">
                    {validationErrors.length > 0
                        ? <span className="validationError radius">
                            <i className="fal fa-exclamation-triangle"></i>
                            {i18n.t('validation.question.form.required')}
                        </span>
                        : null}
                </div>
                {question.optionSet.map(this.formOption)}
            </div>
        )
    }
}

export default Form
